// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730","paginator":"_3DUN","button":"_2-DF","left":"_2U6i","right":"_38y1","page":"_17kD","active":"_2Zt0","separator":"_32KS"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Pagination/Pagination.scss
// module id = poJ6
// module chunks = 0